module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/id_hokkaido-007c61a13917bdda324ea36a83124f3b.jpg";